// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".footer-div[data-v-df34828c]{text-align:center;border-top:1px dotted #747474;width:100%;height:100%;padding-top:27px;background-color:#f1f1f1}.footer-div a[data-v-df34828c]{color:#000;text-decoration:none}.footer-div a[data-v-df34828c]:not(:first-child){padding-left:40px}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
